import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IClassroomResource, IClassroomWebinar } from "../types";

export type IClassroomWebinarQueryParameters = {
    classroom?: RelationalValue<IClassroomResource>;
};

export type IClassroomWebinarQueryResult = IClassroomWebinar;

export const classroomWebinarQuery: IApiQueryFunction<IClassroomWebinarQueryParameters> = ({ classroom }) => {
    if (!classroom) {
        return;
    }

    return {
        method: "GET",
        url: `/classrooms/${mapRelationalValue(classroom)}/webinar`,
    };
};

export const useClassroomWebinarQuery = createApiQueryHook<
    IClassroomWebinarQueryParameters,
    IClassroomWebinarQueryResult
>(classroomWebinarQuery);
